import { useTranslation } from "react-i18next";
import { isTreatmentRateAvailable } from "../campaignFormatUtils";

const CampaignErrorsCell = ({
  status,
  stop,
  totalTreated,
  treatmentPercent,
  progressionPercent,
}) => {
  const { t } = useTranslation();

  const isScheduled = status === "Scheduled";
  const percent = treatmentPercent ?? progressionPercent;
  const showTreatmentRate = isTreatmentRateAvailable(stop);

  const displayValue = isScheduled ? "-" : String(totalTreated ?? 0);

  const percentLabel =
    !isScheduled &&
    showTreatmentRate &&
    percent != null &&
    !Number.isNaN(Number(percent)) &&
    Number(percent) >= 0
      ? t("campaign.treatmentRate", {
          percent: Math.round(Number(percent)),
        })
      : null;

  return (
    <div className="flex flex-col gap-0.5 min-w-0">
      <span className="text-sm font-normal text-[#222222] leading-[22px]">
        {displayValue}
      </span>
      {percentLabel ? (
        <span className="text-xs text-[#5e5e5e] leading-[22px] truncate">
          {percentLabel}
        </span>
      ) : null}
    </div>
  );
};

export default CampaignErrorsCell;
